import { render, staticRenderFns } from "./FlowChart.vue?vue&type=template&id=3585a4e3&scoped=true&"
import script from "./FlowChart.vue?vue&type=script&lang=js&"
export * from "./FlowChart.vue?vue&type=script&lang=js&"
import style0 from "./FlowChart.vue?vue&type=style&index=0&id=3585a4e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3585a4e3",
  null
  
)

export default component.exports